var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStatusRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0000610352,
    width: 24,
    height: 24,
    rx: 8,
    fill: "#DC4252"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9765 14.6484C16.332 14.9766 16.332 15.5508 15.9765 15.8789C15.8124 16.043 15.5937 16.125 15.3749 16.125C15.1288 16.125 14.9101 16.043 14.746 15.8789L11.8749 13.0078L8.9765 15.8789C8.81244 16.043 8.59369 16.125 8.37494 16.125C8.12885 16.125 7.9101 16.043 7.74603 15.8789C7.39056 15.5508 7.39056 14.9766 7.74603 14.6484L10.6171 11.75L7.74603 8.87891C7.39056 8.55078 7.39056 7.97656 7.74603 7.64844C8.07416 7.29297 8.64838 7.29297 8.9765 7.64844L11.8749 10.5195L14.746 7.64844C15.0742 7.29297 15.6484 7.29297 15.9765 7.64844C16.332 7.97656 16.332 8.55078 15.9765 8.87891L13.1054 11.7773L15.9765 14.6484Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusRejected);
export default __webpack_public_path__ + "static/media/icon-status-rejected.1ce1e44eb496b9c73b896e2173745a19.svg";
export { ForwardRef as ReactComponent };